<template>
    <transition name="layout-fade">
        <Loader v-if="loading" style="max-width: 100%"/>

        <v-layout wrap>
            <Navigation/>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    import Order from '../../../../api/order'
    import Loader from '../../../../components/Loader/Layout'
    import Navigation from './NavigationEnded'

    export default {
        name: 'orderLayoutEnded',
        components: {Navigation, Loader},
        data: () => ({
            loading: false
        }),
        created () {
            this.loading = true

            Order
                .getAllEnded()
                .then(response => this.$store.commit('storeEndedOrders', response.data.data))
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        },
    }
</script>
